import { Fragment, ReactElement } from 'react';
import { Typography } from '@mui/material';

import { IDeFiItem } from 'modules/defi/types';

import { useStyles } from './useStyles';

interface ITokensProps {
  tokens: IDeFiItem['tokens'];
}

export function Tokens({ tokens }: ITokensProps): ReactElement {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.icons}>
        {tokens.map(token => (
          <img
            key={token.name}
            alt={token.name}
            className={classes.icon}
            src={token.icon}
          />
        ))}
      </div>

      <Typography variant="body1">
        {tokens.map((token, i) => (
          <Fragment key={token.name}>
            {/* eslint-disable-next-line no-useless-concat */}
            {i !== 0 ? `/ ${token.name}` : token.name}{' '}
          </Fragment>
        ))}
      </Typography>
    </div>
  );
}
